<template>
  <div class="cores">
    <template>
      <v-card>
        <v-card-title>
          Whitelist FIs
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card>
          <v-container fluid>
            <v-select
              :items="configTypesList"
              :clearable="true"
              @change="selectConfigType()"
              v-model="configTypeDropdown"
              label="Select Config Type"
            ></v-select>

            <v-row>
              <v-data-table
                :headers="headers"
                :items="displayedVersionFiidsByRow"
                :items-per-page="10"
                class="elevation-2">
                  <template slot="items" slot-scope="props">
                      <td>{{ props.item.configType }}</td>
                      <td>{{ props.item.fiid }}</td>
                      <td>
                        <v-btn v-if="userWritePrivileges"
                          color="red"
                          dark
                          @click="deleteFiid(props.item)">
                        <font-awesome-icon icon="trash-alt" class="pr-1" />Delete
                        </v-btn>
                      </td>
                      <td>
                        <v-dialog
                          v-model="editDialog"
                          persistent
                          max-width="500px">
                          <template v-slot:activator="{ on }">
                            <v-btn color="info" dark class="pr-1" v-on="on">
                             <font-awesome-icon icon="edit" class="pr-1"/>Edit
                            </v-btn>
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">Edit FI ID</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="6" md="4">
                                    <v-text-field
                                    label="Config Type"
                                    :value="props.item.configType"
                                    disabled>
                                    </v-text-field>
                                    <v-text-field
                                    type="text"
                                    label="FI ID"
                                    v-model="editFiid"
                                    :placeholder="props.item.fiid"
                                    :rules="['Required']">
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="closeEdit()">Cancel</v-btn>
                              <v-btn color="blue darken-1" text
                              @click="editItem(props.item, editFiid)">Save Changes</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>

                      </td>
                  </template>
                </v-data-table>
            </v-row>
          </v-container>
        </v-card>
      </v-card>


      <v-dialog
        v-model="addDialog"
        persistent
        max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn
          color="primary"
          dark
          class="mb-2"
          v-on="on">Add FI ID
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add FI</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                  v-model="selectedConfigType"
                  type="text"
                  label="Config Type"
                  :rules="['Required']">
                  </v-text-field>
                  <v-text-field
                  v-model="newFiid"
                  type="text"
                  label="FI ID"
                  :rules="['Required']">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeAdd()">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="addFiid()">Add</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import axios, { AxiosResponse } from 'axios';
import GenericWhitelistService from '@/GenericWhitelistService';
import RequestService from '@/RequestService';

@Component
export default class GenericWhitelistConfig extends Vue {
  /*eslint-disable */
  data() {
    return {
      editDialog: false,
      addDialog: false,
      newFiid: "",
      selectedVersion: "v1",
      userWritePrivileges: false,
    };
  }

  /* eslint-enable */
  versionFiids=[];

  versionFiidsByRow=[];

  displayedVersionFiidsByRow = [];

  selectedConfigType = '';

  configTypeDropdown = '';

  configTypesList=[];

  editFiid = '';

  headers = [
    {
      text: 'ConfigType', value: 'item', sortable: true, align: 'left',
    },
    {
      text: 'FI ID', value: 'item', sortable: true, align: 'left',
    },
    { text: 'Actions', value: 'action', sortable: false },
  ];

  emptyPayload = {
    configType: '',
    version: 'v1',
    fiIds: [],
  };

  editedPayload = this.emptyPayload;

  async addFiid() {
    let fiidListFromConfigType = [];
    Object.keys(this.versionFiids).forEach((idx) => {
      if (this.versionFiids[idx].configType === this.selectedConfigType) {
        fiidListFromConfigType = this.versionFiids[idx].fiIds;
      }
    });

    if (fiidListFromConfigType.includes(this.newFiid)) {
      window.alert(`FI ID ${this.newFiid} already exists in ${this.selectedConfigType}.`);
    } else if (this.selectedConfigType === '') {
      window.alert('Config Type cannot be blank.');
    } else if (this.newFiid === '') {
      window.alert('FI ID cannot be blank.');
    } else if (window.confirm(`Are you sure you want to add FI ID: ${this.newFiid}`
      + ` to ConfigType: ${this.selectedConfigType}?`)) {
      this.addDialog = true;
      fiidListFromConfigType.push(this.newFiid);
      this.editedPayload.fiIds = fiidListFromConfigType;
      this.editedPayload.version = 'v1';
      this.editedPayload.configType = this.selectedConfigType;
      GenericWhitelistService.postGenericWhitelistConfig(this.editedPayload);


      this.versionFiids = await GenericWhitelistService.getAllConfigTypesForVersion('v1');
      this.versionFiidsByRow = await GenericWhitelistService.separateVersionFiidsToRows(this.versionFiids);
      this.configTypesList = await GenericWhitelistService.getConfigTypesList(this.versionFiids);

      this.selectConfigType();

      this.newFiid = Object.assign('', this.newFiid);
      this.selectedConfigType = '';
      this.editedPayload = this.emptyPayload;
      this.closeAdd();
    }
  }

  async deleteFiid(item) {
    if (window.confirm(`Are you sure you want to delete FI ID: ${item.fiid} in ConfigType: ${item.configType}?`)) {
      const payload = this.emptyPayload;
      let fiids = [];

      Object.keys(this.versionFiids).forEach((idx) => {
        if (this.versionFiids[idx].configType === item.configType) {
          fiids = this.versionFiids[idx].fiIds;
          Object.keys(fiids).forEach((spliceIdx) => {
            if (fiids[spliceIdx] === item.fiid) {
              fiids.splice(spliceIdx, 1);
            }
          });

          payload.fiIds = fiids;
          payload.configType = item.configType;
          GenericWhitelistService.postGenericWhitelistConfig(JSON.parse(JSON.stringify(payload)));

          this.versionFiidsByRow = GenericWhitelistService.separateVersionFiidsToRows(this.versionFiids);
          this.configTypesList = GenericWhitelistService.getConfigTypesList(this.versionFiids);
          this.selectConfigType();
        }
      });
    }
  }

  async addEditedFiid(editedFiid, currentConfigType) {
    let fiidListFromConfigType = [];
    Object.keys(this.versionFiids).forEach((idx) => {
      if (this.versionFiids[idx].configType === currentConfigType) {
        fiidListFromConfigType = this.versionFiids[idx].fiIds;
      }
    });

    if (fiidListFromConfigType.includes(this.newFiid)) {
      window.alert(`FI ID ${this.newFiid} already exists in ${this.selectedConfigType}.`);
    } else {
      this.editDialog = true;
      fiidListFromConfigType.push(editedFiid);
      this.editedPayload.fiIds = fiidListFromConfigType;
      this.editedPayload.version = 'v1';
      this.editedPayload.configType = currentConfigType;
      GenericWhitelistService.postGenericWhitelistConfig(this.editedPayload);


      this.versionFiids = await GenericWhitelistService.getAllConfigTypesForVersion('v1');
      this.versionFiidsByRow = await GenericWhitelistService.separateVersionFiidsToRows(this.versionFiids);
      this.configTypesList = await GenericWhitelistService.getConfigTypesList(this.versionFiids);

      this.selectConfigType();

      this.newFiid = Object.assign('', this.newFiid);
      this.selectedConfigType = '';
      this.editedPayload = this.emptyPayload;
      this.closeEdit();
    }
  }

  async deleteEditedFiid(item) {
    const payload = this.emptyPayload;
    let fiids = [];

    Object.keys(this.versionFiids).forEach((idx) => {
      if (this.versionFiids[idx].configType === item.configType) {
        fiids = this.versionFiids[idx].fiIds;
        Object.keys(fiids).forEach((spliceIdx) => {
          if (fiids[spliceIdx] === item.fiid) {
            fiids.splice(spliceIdx, 1);
          }
        });

        payload.fiIds = fiids;
        payload.configType = item.configType;
        GenericWhitelistService.postGenericWhitelistConfig(JSON.parse(JSON.stringify(payload)));

        this.versionFiidsByRow = GenericWhitelistService.separateVersionFiidsToRows(this.versionFiids);
        this.configTypesList = GenericWhitelistService.getConfigTypesList(this.versionFiids);
        this.selectConfigType();
      }
    });
  }

  async editItem(item) {
    if (this.editFiid.trim() === '' || this.editFiid.trim() === item.fiid.trim()) {
      window.alert('No changes made!');
      this.closeEdit();
      return;
    }

    const currentFiid = item.fiid;
    const currentConfigType = item.configType;

    if (window.confirm(`Are you sure you want to replace FI ID: ${currentFiid
    } with FI ID: ${this.editFiid} in ConfigType: ${currentConfigType}?`)) {
      // delete old fiid
      this.deleteEditedFiid(item);

      // replace with editFiid
      this.addEditedFiid(this.editFiid, currentConfigType);
      this.editFiid = '';
    }
  }

  selectConfigType() {
    this.displayedVersionFiidsByRow = this.versionFiidsByRow;

    if (this.configTypeDropdown !== undefined && this.configTypeDropdown !== '') {
      this.displayedVersionFiidsByRow = this.versionFiidsByRow.filter(fi => fi.configType === this.configTypeDropdown);
    }
  }


  closeEdit() {
    this.editDialog = false;

    setTimeout(() => {
    }, 300);
  }

  closeAdd() {
    this.addDialog = false;

    setTimeout(() => {
      this.newFiid = '';
    }, 300);
  }

  async mounted() {
    this.versionFiids = await GenericWhitelistService.getAllConfigTypesForVersion('v1');
    this.versionFiidsByRow = await GenericWhitelistService.separateVersionFiidsToRows(this.versionFiids);
    this.displayedVersionFiidsByRow = this.versionFiidsByRow;
    this.userWritePrivileges = await RequestService.checkCredentials();
    this.configTypesList = await GenericWhitelistService.getConfigTypesList(this.versionFiids);
  }
}
</script>
